export function convertKeysToSnakeCase(object: any): any {
  // Preserve FormData instances untouched
  if (object instanceof FormData) {
    return object
  }

  // Preserve JavaScript Date instances so they keep their ISO string when serialized
  if (object instanceof Date) {
    return object
  }

  // If this is a Day.js object (identified by the _isDayjs flag) convert it to a native Date
  // if (object && typeof object === 'object' && (object as any)._isDayjs) {
  //   return (object as any).toDate()
  // }

  // Recursively handle arrays
  if (Array.isArray(object)) {
    return object.map(item => convertKeysToSnakeCase(item))
  }

  // Recursively convert keys for plain objects
  if (typeof object === 'object' && object !== null) {
    return Object.entries(object).reduce((newObject, [key, value]) => {
      const preserveLeadingUnderscore
        = typeof key === 'string' && key.startsWith('_')
      const convertedKey = preserveLeadingUnderscore ? key : useSnakeCase(key)

      return {
        ...newObject,
        [convertedKey]: convertKeysToSnakeCase(value),
      }
    }, {})
  }

  // Primitive value – return as-is
  return object
}

export function convertKeysToCamelCase(object: any): any {
  if (Array.isArray(object)) {
    return object.map(item => convertKeysToCamelCase(item))
  }
  if (typeof object === 'object' && object !== null) {
    return Object.entries(object).reduce((newObject, [key, value]) => {
      // Special case for leading underscores like _destroy, _delete, etc.
      const preserveLeadingUnderscore = typeof key === 'string' && key.startsWith('_')
      if (preserveLeadingUnderscore) return { ...newObject, [key]: convertKeysToCamelCase(value) }

      // Default case: convert to camelCase
      return { ...newObject, [useCamelCase(key)]: convertKeysToCamelCase(value) }
    }, {})
  }
  return object
}
